//function to check where to show banner 
export const shouldShowSection = (exceptionPaths: string[] = []) => {
    if (exceptionPaths.some(path => location.pathname.includes(path))) {
        return true;
    }
    if(!location.pathname.includes("/apply-job/from") && !location.pathname.includes("/view/") && !location.pathname.includes("/job-alerts")) {
        return true;
    }
    return false;
};


export const ShouldShowSalary = (salary: string | number | null) => {
    return salary && salary !== "NA";
};